enum SessionStorageKey {
  UtmSource = 'utm_source',
  UtmMedium = 'utm_medium',
  UtmCampaign = 'utm_campaign',
}

export default SessionStorageKey;
